import { Navigate, Route } from "react-router-dom";
import { RequirePermission } from "../auth/Guard";
import AdminDataRequestsPage from "../pages/admin/AdminDataRequestsPage/AdminDataRequestsPage";
import AdminLayout from "../pages/admin/AdminLayout";
import AdminModulesPage from "../pages/admin/AdminModulesPage/AdminModulesPage";
import AdminBrandingPage from "../pages/admin/AdminBrandingPage/AdminBrandingPage";
import AdminOrganizationsPage from "../pages/admin/AdminOrganizationsPage/AdminOrganizationsPage";
import AdminPoliciesPage from "../pages/admin/AdminPoliciesPage/AdminPoliciesPage";
import AdminRolesPage from "../pages/admin/AdminRolesPage/AdminRolesPage";
import AdminUsersPage from "../pages/admin/AdminUsersPage/AdminUsersPage";
import OrganizationDetailsPage from "../pages/organization/OrganizationDetailsPage/OrganizationDetailsPage";
import OrganizationPeoplePage from "../pages/organization/OrganizationPeoplePage/OrganizationPeoplePage";

/** An organization's own administration, for its administrators (docs/adr/0017). */
export function organizationRoutes(): React.JSX.Element {
  return (
    <Route
      path="/organization"
      element={
        <RequirePermission permission="core.organization">
          <AdminLayout />
        </RequirePermission>
      }
    >
      <Route index element={<Navigate to="people" replace />} />
      <Route path="people" element={<OrganizationPeoplePage />} />
      <Route path="details" element={<OrganizationDetailsPage />} />
    </Route>
  );
}

/** The Admin Center: part of the core, for suite administrators. */
export function adminCenterRoutes(): React.JSX.Element {
  return (
    <Route
      path="/admin"
      element={
        <RequirePermission permission="core.admin">
          <AdminLayout />
        </RequirePermission>
      }
    >
      <Route index element={<Navigate to="users" replace />} />
      <Route path="users" element={<AdminUsersPage />} />
      <Route path="organizations" element={<AdminOrganizationsPage />} />
      <Route path="roles" element={<AdminRolesPage />} />
      <Route path="modules" element={<AdminModulesPage />} />
      <Route path="policies" element={<AdminPoliciesPage />} />
      <Route path="data-requests" element={<AdminDataRequestsPage />} />
      <Route path="branding" element={<AdminBrandingPage />} />
    </Route>
  );
}
